import { useEffect } from 'react';
import useInfiniteScroll from 'library/components/entity-loader/hooks/with-infinite-scroll';
import { LoaderBox } from './loader-box';

const DEFAULT_STYLE = { width: '1px', height: '1px', display: 'block' };

const EntityLoader = ({
  isLoading,
  isStopped = false,
  currentAmount,
  hasMore,
  onScroll,
  onReset,
}) => {
  const shouldProceed = hasMore && !isLoading && !isStopped;
  const [lastElementRef] = useInfiniteScroll({ onScroll });

  useEffect(() => {
    if (currentAmount === 0 && !isLoading) {
      onScroll();
    }

    // reset data and filters to defaults on unmount if needed
    return () => {
      if (onReset) {
        onReset();
      }
    };
  }, []);

  // if all data loaded
  if (!shouldProceed) {
    return null;
  }

  if (isLoading) {
    return (
      <LoaderBox />
    );
  }

  // container, placed after data elements,
  // onScroll callback is triggered when it's reached by user scroll
  return <div ref={lastElementRef} style={DEFAULT_STYLE} />;
};

export default EntityLoader;
